export default "__VITE_ASSET__Bs3W_Tg2__"